import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const labelVariants = cva("text-sm font-medium leading-relaxed peer-disabled:cursor-not-allowed peer-disabled:opacity-70");

interface LabelProps extends React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> {
  required?: boolean;
  error?: string;
}

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  LabelProps
>(({ className, required, error, children, ...props }, ref) => (
  <div className="flex flex-col gap-1.5">
    <LabelPrimitive.Root 
      ref={ref} 
      className={cn(
        labelVariants(),
        error && "text-danger",
        className
      )} 
      {...props}
    >
      <div className="flex items-center gap-1">
        {children}
        {required && <span className="text-danger" aria-label="required">*</span>}
      </div>
    </LabelPrimitive.Root>
    {error && <p className="text-xs text-danger">{error}</p>}
  </div>
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };

